import { render, staticRenderFns } from "./IneColumnChart.vue?vue&type=template&id=051036c2&"
import script from "./IneColumnChart.vue?vue&type=script&lang=js&"
export * from "./IneColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports